import { SfSchool, SfSchoolSubscriptions } from "@/types/generalTypes";
import getMonthName from "./format/getMonthName";
import dateTimeFormat from "./format/dateTimeFormat";

export function getSchoolStartMonth(
  school: SfSchool | null | undefined,
): number {
  if (!school || !school.year_start_month) {
    return -1;
  }
  return school.year_start_month;
}

export function getSchoolCurrentYear(
  school: SfSchool | null | undefined,
): number {
  const startMonth = getSchoolStartMonth(school);
  if(startMonth === -1) { 
    return -1;
  }
  const currentMonth = new Date().getMonth() + 1;
  let year = new Date().getFullYear();
  if (currentMonth < startMonth) {
    year--;
  }
  return year;
}

export function getSchoolMaxStudentsPerClass(
  school: SfSchool | null | undefined,
) {
  if (!school || !school.students_per_class_limit) {
    return 0;
  }
  return school.students_per_class_limit;
}

export function getAcademicMonths(
  startMonth: number,
  accademicYear: number,
  onlyPast = true,
) {
  const now = new Date();
  if(startMonth < 0) {
    startMonth = now.getMonth() + 2;
    accademicYear = now.getFullYear() + accademicYear;
  }
  let endMonth = now.getMonth();
  if (endMonth < 0) {
    endMonth = 12;
  }
  const monthOptions = [];
  for (let i = 0; i < 12; i++) {
    let month = startMonth + i;
    let year = accademicYear;
    if (month > 12) {
      month = month - 12;
      year = accademicYear + 1;
    }
    const monthString = month < 10 ? "0" + month : month;
    monthOptions.push({
      value: i,
      from: year + "-" + monthString + "-01",
      label: getMonthName(month - 1) + " " + year,
    });
    if (onlyPast && year == now.getFullYear() && month > endMonth) {
      break;
    }
  }
  return monthOptions;
}

export function getAcademicWeeks(
  startMonth: number,
  accademicYear: number,
  firstDay: number,
  onlyPast = true,
) {
  const weeks = [];
  const date = new Date();
  if (startMonth < 0) {
    startMonth = date.getMonth() + 2;
    accademicYear = date.getFullYear() + accademicYear;
  }
  date.setFullYear(accademicYear);
  date.setMonth(startMonth - 1);
  date.setDate(1);
  let weekDay = date.getDay();
  weekDay = weekDay - firstDay;
  if (weekDay < 0) {
    weekDay = 7 + weekDay;
  }
  date.setDate(1 - weekDay);
  const limitDate = new Date();
  for (let i = 0; i < 55; i++) {
    const from = dateTimeFormat(date, "[y]-[m]-[d]");
    date.setDate(date.getDate() + 6);
    const to = dateTimeFormat(date, "[y]-[m]-[d]");
    weeks.push({
      from,
      to,
      value: i,
      label: from + " to " + to,
    });
    date.setDate(date.getDate() + 1);
    if (onlyPast && date > limitDate) {
      break;
    }
  }
  return weeks;
}

export function getSchoolExpireDate(
  cSubs: SfSchoolSubscriptions,
  fSubs: SfSchoolSubscriptions,
) {
  if (fSubs.spelling && !fSubs.spelling.is_trial) {
    return new Date(fSubs.spelling.expireon);
  }
  if (fSubs.maths && !fSubs.maths.is_trial) {
    return new Date(fSubs.maths.expireon);
  }
  if (cSubs.spelling && !cSubs.spelling.is_trial) {
    return new Date(cSubs.spelling.expireon);
  }
  if (cSubs.maths && !cSubs.maths.is_trial) {
    return new Date(cSubs.maths.expireon);
  }
  return null;
}

export function getSchoolDaysToExpire(
  cSubs: SfSchoolSubscriptions | null,
  fSubs: SfSchoolSubscriptions | null,
) {
  if (!cSubs || !fSubs) {
    return 0;
  }
  const expireDate = getSchoolExpireDate(cSubs, fSubs);
  if (!expireDate) {
    return 0;
  }
  return Math.ceil((expireDate.getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24);
}
